import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { TiTick } from "react-icons/ti";
import ReactStars from "react-rating-stars-component";

const AddReviewModal = (props) => {
  const {modalType, changedField}= props

  const ratingChanged = (newRating) => {
    props.setChangedField((prev)=>({...prev, rating:newRating}))
  };

  return (
    <div>
      <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Add Review</ModalHeader>
      <ModalBody>
      <div className="row pt-2">
  <div className="col-lg-12">
    <div className="">
      
      <div className="d-flex justify-content-center align-items-center">
        <div className="form-validation">
         {modalType==='edit'||modalType==='add'? <form className="form-valide" >
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group row">
                  <label className="col-lg-4 col-form-label" >Rating:
                  </label>
                  <div className="col-lg-8">
                  <ReactStars
    count={5}
    onChange={ratingChanged}
    size={24}
    activeColor="#ffd700"
  />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-lg-4 col-form-label" >Risk:
                  </label>
                  <div className="col-lg-8">

                    <div className='d-flex justify-content-around risk-rating'>
                        <div >{changedField.risk==='low' &&<TiTick/> }  <span onClick={(e)=>props.setChangedField(prev=>({...prev, risk:'low'}))} className='badge badge-success'>  Low</span></div>
                        <div>{changedField.risk==='medium' &&<TiTick/> }  <span onClick={(e)=>props.setChangedField(prev=>({...prev, risk:'medium'}))} className='badge badge-warning'>Medium</span></div>
                        <div>{changedField.risk==='high' &&<TiTick/> }   <span onClick={(e)=>props.setChangedField(prev=>({...prev, risk:'high'}))} className='badge badge-danger'>High</span>  </div>
                    
                    
                   
                    </div>
                    {/* <input type="text" className={changedField.businessname?"form-control havevalue": "form-control"} id="val-username" name="val-username" placeholder="Enter a business name" value={props.changedField.businessname} onChange={(e)=>props.setChangedField(prev=>({...prev, businessname:e.target.value}))} /> */}
                  </div>
                </div>
                
                
                <div className="form-group row">
                  <label className="col-lg-4 col-form-label" htmlFor="val-suggestions">Comment:
                  </label>
                  <div className="col-lg-12">
                    <textarea className={changedField.address?"form-control havevalue": "form-control"} id="val-suggestions" name="val-suggestions" rows={5} placeholder="Write your comment" value={props.changedField.comment} onChange={(e)=>props.setChangedField(prev=>({...prev, comment:e.target.value}))}/>
                  </div>
                </div>
                

            
              </div>
             
            </div>
          </form>
          :
          <div>
          <div className="form-group row">
                 <label className="col-lg-4 col-form-label" ><span className="badge badge-info">Name:</span>
                 </label>
                 <div className="col-lg-8">
                   <p className="mt-2 badge badge-dark">{props.changedField.name}</p>
                 </div>
               </div>
          
               <div className="form-group row">
                 <label className="col-lg-4 col-form-label" ><span className="badge badge-info">Email:</span>
                 </label>
                 <div className="col-lg-8">
                   <p className="mt-2 badge badge-dark">{props.changedField.email}</p>
                 </div>
               </div>
               <div className="form-group row">
                 <label className="col-lg-4 col-form-label" ><span className="badge badge-info ">Phone:</span>
                 </label>
                 <div className="col-lg-8">
                   <p className="mt-2 ">{props.changedField.phone? <span className="badge badge-dark">{ props.changedField.phone}</span> : <span className="badge badge-pill badge-secondary">Not Added</span> }</p>
                 </div>
               </div>
          </div>}
        </div>
      </div>
    </div>
  </div>

</div>
      </ModalBody>
      <ModalFooter>
       
        <Button color="secondary" onClick={props.toggle}>
          {modalType==='edit' ?'Cancel' : 'Close'}
        </Button>{' '}
       {modalType !=='view' &&  <Button color="primary" onClick={modalType==='edit'?props.handleSubmit : props.handleSubmit&& props.handleSubmit}>
          Submit
        </Button>}
      </ModalFooter>
    </Modal>

</div>
  )
}

export default AddReviewModal
